import type { EventFilter, TelemetryEvent } from './types';

const FILTERED = '[Filtered]';

// The `[?&]` alternation is what reaches the params of a hash-routed URL, which carries its own `?` inside the fragment.
const PARAM_VALUE = /([?&][^?&=#]+=)[^&#]*/g;

/** Replaces every query-parameter value with `[Filtered]`, keeping the path, the parameter names and the fragment. */
export function redactUrlParams(url: string): string {
  return url.replace(PARAM_VALUE, `$1${FILTERED}`);
}

/**
 * Redacts the query-parameter values of every URL an event carries, in place; never drops the event.
 *
 * Reads: `view.url`, `view.referrer`, `resource.url`, `error.resource.url`.
 */
export function redactEventUrlParams<T extends TelemetryEvent>(): EventFilter<T> {
  return (event) => {
    event.view.url = redactUrlParams(event.view.url);
    if (event.view.referrer) event.view.referrer = redactUrlParams(event.view.referrer);
    if (event.resource?.url) event.resource.url = redactUrlParams(event.resource.url);
    if (event.error?.resource?.url) event.error.resource.url = redactUrlParams(event.error.resource.url);
    return true;
  };
}
